import React, { useEffect, useState } from "react";
import Block from "../../../adapters/helpers/Block";
import { mediaQueryHOC } from "../../../adapters/helpers/Hooks";
import { AnalyticsConstants } from "../../../adapters/helpers/ConstantsGA";
import { StartGuideBlockConstants } from "../../../adapters/helpers/Constants";

const StartGuideSignupForm = (props) => {
  const block = new Block(props);
  const { isXSmall, isSmall } = props;
  const className = block.getFieldValue(StartGuideBlockConstants.className);
  const desktopButtonAsset = block.getFieldValue(
    StartGuideBlockConstants.desktopButtonAsset
  );
  const mobileButtonAsset = block.getFieldValue(
    StartGuideBlockConstants.mobileButtonAsset
  );

  const checkIsMobile = () => {
    return isXSmall || isSmall ? true : false;
  };

  return (
    <>
      {checkIsMobile() ? (
        <div
          className={`${className} mobile-button event_button_click`}
          data-action-detail={AnalyticsConstants.signUpEvent}
        >
          <img src={mobileButtonAsset?.fields?.file?.url} />
        </div>
      ) : (
        <div
          className={`${className} desktop-button event_button_click`}
          data-action-detail={AnalyticsConstants.signUpEvent}
        >
          <img src={desktopButtonAsset?.fields?.file?.url} />
        </div>
      )}
    </>
  );
};

export default mediaQueryHOC(StartGuideSignupForm);
